import { render, staticRenderFns } from "./SchoolSelect.vue?vue&type=template&id=36f29d25&scoped=true&"
import script from "./SchoolSelect.vue?vue&type=script&lang=js&"
export * from "./SchoolSelect.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSelect.vue?vue&type=style&index=0&id=36f29d25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f29d25",
  null
  
)

export default component.exports